<template>
  <div class="improveInformationDialog">
    <!--      <img @click="handleCancel" class="close-dialog" src="../../../assets/img/header/closeDialog.png" alt="close" />-->
    <div class="header">还差一步，开启全网商机</div>
    <div class="content">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" class="form">
        <el-form-item class="one-item" prop="zhiwu" label="请选择您的职位">
          <div class="form-list">
            <template v-for="item in zhiwu_options">
              <div
                class="form-list-item"
                :class="{ active: item === form.zhiwu }"
                :key="item"
                @click="optionsClick(item)"
              >
                {{ item }}
              </div>
            </template>
          </div>
        </el-form-item>
        <el-form-item prop="dwmc" label="您的公司名称">
          <el-input
            class="ellipsis"
            autocomplete="off"
            type="text"
            v-model="form.dwmc"
            placeholder="请输入公司名称"
            maxLength="50"
            size="medium"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="linkName" label="您的姓名">
          <el-input
            class="ellipsis"
            autocomplete="name"
            type="text"
            v-model="form.linkName"
            placeholder="请输入您的姓名"
            maxLength="20"
            size="medium"
          >
          </el-input>
        </el-form-item>

        <el-form-item class="buttons-container">
          <el-button class="btn-cancel" @click="handleCancel()">放弃</el-button>
          <el-button type="primary" class="btn-save" :disabled="btnDisabled" @click="handleSave('form')"
            >开启商机</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { restUPersonalMembersInfoUpdate } from "../../../services/home";
import { DEED_MAP, OID_MAP } from "../../../utils/constants/constants.track";

export default {
  name: "DialogInformationImprove",
  data() {
    return {
      form: {
        linkName: "",
        dwmc: "",
        zhiwu: "",
      },
      rules: {
        linkName: [{ required: true, message: "*请输入您的姓名", trigger: ["blur", "change"] }],
        dwmc: [{ required: true, message: "*请输入企业名称", trigger: ["blur", "change"] }],
        zhiwu: [{ required: true, message: "*请选择职位", trigger: ["blur", "change"] }],
      },
      zhiwu_options: ["法人", "总经理", "管理人员", "销售人员", "业务人员", "其他"],
    };
  },
  computed: {
    isShowDialogInformationImprove() {
      return this.$store.getters["basic/isShowDialogInformationImprove"];
    },
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    btnDisabled() {
      const type = Object.values(this.form).filter((item) => item).length === 3;
      return !type;
    },
    updateIsShowDialogInformationImproveFrom() {
      return this.$store.getters["basic/updateIsShowDialogInformationImproveFrom"];
    },
  },
  watch: {
    userInfo: {
      handler(userInfo) {
        this.form.linkName = userInfo.linkName;
        this.form.dwmc = userInfo.dwmc;
        this.form.zhiwu = userInfo.zhiwu;
        this.form.dwmc ? (this.form.dwmc = this.form.dwmc.slice(0, 50)) : "";
        this.form.linkName ? (this.form.linkName = this.form.linkName.slice(0, 20)) : "";
        if (userInfo.zhiwu) {
          this.zhiwu_options = Array.from(new Set(this.zhiwu_options));
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    asyncValidate(formName) {
      return new Promise((resolve) => {
        this.$refs[formName].validate((validate) => {
          resolve(validate);
        });
      });
    },
    async handleSave(formName) {
      const valid = await this.asyncValidate(formName);
      if (!valid) return;
      this.$track(DEED_MAP.CLICK, OID_MAP.INFORMATION_IMPROVE_CONFIRM_CLICK);
      try {
        await restUPersonalMembersInfoUpdate({
          dwmc: this.form.dwmc,
          linkName: this.form.linkName,
          zhiwu: this.form.zhiwu,
          source: 5, // 信息来源 1弹窗  2账号信息页  3APP端  4H5端 5home页
        });
        this.$store.commit("basic/updateUserInfo", {
          ...this.userInfo,
          dwmc: this.form.dwmc,
          linkName: this.form.linkName,
          zhiwu: this.form.zhiwu,
        });
        this.$store.commit("basic/updateIsShowDialogInformationImprove", false);
        this.$emit("success");
        this.$message.success(`保存成功`);
      } catch (e) {
        e;
      }
    },
    handleCancel() {
      this.$track(DEED_MAP.CLICK, OID_MAP.INFORMATION_IMPROVE_CANCEL_CLICK);
      this.$emit("close");
      this.$store.commit("basic/updateIsShowDialogInformationImprove", false);
    },
    optionsClick(item) {
      this.form.zhiwu = item;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/config";

.improveInformationDialog {
  width: 367px;
  height: 479px;
  .el-form-item {
    margin-bottom: 24px;
    &.one-item {
      margin-bottom: 12px;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 35px;
    }

    ::v-deep .el-input__inner {
      //height: 36px;
      //line-height: 36px;
      border-radius: 4px;
    }
    ::v-deep .el-form-item__label {
      color: #45464a;
      position: relative;
      left: -12px;
      line-height: 20px;
      margin-bottom: 10px;
    }
  }
  .header {
    padding-top: 8px;
    padding-bottom: 40px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #45464a;
    line-height: 25px;
  }

  .content {
    .form {
      .form-list {
        display: flex;
        flex-wrap: wrap;
        padding-top: 1px;
        .form-list-item {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          color: #45464a;
          line-height: 20px;
          background: #f5f6f8;
          border-radius: 16px;
          padding: 6px 13px;
          border: 1px solid #f5f6f8;
          margin-right: 16px;
          margin-bottom: 10px;
          max-width: 153px;
          white-space: nowrap; /* 防止文本换行 */
          overflow: hidden; /* 隐藏溢出部分的文本 */
          text-overflow: ellipsis; /* 使用省略号表示溢出的部分 */
          cursor: pointer;
          &:hover,
          &.active {
            color: $theme-color;
            border: 1px solid $theme-color;
            background: #fff;
            font-weight: 550;
          }
        }
      }

      .icon {
        margin-top: 13px;
        margin-left: 7px;
      }
      .buttons-container {
        margin-top: 37px;
        display: flex;

        .btn-cancel {
          width: 165px;
          height: 44px;
          font-size: 16px;
          border-radius: 4px;
          color: #7c7d81;
        }

        .btn-save {
          width: 165px;
          height: 44px;
          font-size: 16px;
          border-radius: 4px;
          margin-left: 22px;
        }
      }
    }
  }
}
</style>
